import completeProfileTemplate from './completeProfile/completeProfile.html';
import loginModalTemplate from './login/login.html';
import editProfileModalTemplate from './editProfile/editProfile.html';
import editContactInformationModalTemplate from './editContactInformation/editContactInformation.html';
import editCreditCardModalTemplate from './editCreditCard/editCreditCard.html';
import editMembershipModalTemplate from './editMembership/editMembership.html';
import editCitiesModalTemplate from './editCities/editCities.html';
import enterPromoModalTemplate from './enterPromo/enterPromo.html';
import forgotPasswordModalTemplate from './forgotPassword/forgotPassword.html';
import contactSupportModalTemplate from './contactSupport/contactSupport.html';
import shareLinkModalTemplate from './shareLink/shareLink.html';
import bookingWidgetModalTemplate from './bookingWidget/bookingWidgetModal.html';
import getMembershipModalTemplate from './getMembership/getMembershipModal.html';
import searchModalTemplate from './search/searchModal.html';
import confirmationModalTemplate from './confirmation/template.html';
import termsModalTemplate from './terms/terms.html';

modalService.$inject = [
  '$uibModal',
  '$rootScope',
  '$uibModalStack',
  'tl.user.service',
  'tl.auth.service',
  '$q'
];

export default function modalService($uibModal, $rootScope, $uibModalStack, userService, authService, $q) {
  class ModalService {
    /**
      @param {Object} options
      @param {String} options.modalMessage - Message to diplay in the modal
      @param {String} [options.modalHeader] - Value to use as the modal's header
      @param {String} [options.confirmBtnTxt] - Value to use as the modal's confirm button text
      @param {String} [options.confirmingBtnTxt] - Value to use as the modal's confirm button text while saving
      @param {String} [options.cancelBtnTxt] - Value to use as the modal's cancel button text
      @return Promise
    */
    confirmation(options) { //eslint-disable-line
      if (!options) throw new Error('modalService - confirmation() - options is required');
      if (!options.modalMessage) throw new Error('modalService - confirmation() - options.modalMessage is required');

      const deferred = $q.defer();

      const modalInstance = $uibModal.open({
        template: confirmationModalTemplate,
        controller: 'confirmationModalCtrl',
        windowClass: 'confirmation-modal-window',
        size: options.size || 'md',
        resolve: {
          modalHeader: function() {
            return options.modalHeader || null;
          },
          modalMessage: function() {
            return options.modalMessage || null;
          },
          confirmingBtnClass: function() {
            return options.confirmingBtnClass || null;
          },
          confirmBtnTxt: function() {
            return options.confirmBtnTxt || null;
          },
          confirmingBtnTxt: function() {
            return options.confirmingBtnTxt || null;
          },
          hideCancelBtn: function() {
            return options.hideCancelBtn || false;
          },
          cancelBtnTxt: function() {
            return options.cancelBtnTxt || null;
          },
          deferred: function() {
            return deferred;
          }
        }
      });

      return $q((resolve, reject) => {
        deferred.promise
          .then(result => {
            if (result === false) {
              return modalInstance.close(null);
            }

            return resolve({
              confirm: result,
              modalInstance: modalInstance
            });
          })
          .catch(_catchModalError(reject));
      });
    }

    completeProfile(authConfig, success, error) { //eslint-disable-line
      if (!$rootScope.currentUser) {
        if (error) error(false);
        return;
      }

      if (!authConfig.keysToVerify || authConfig.keysToVerify.length < 1) {
        if (error) error(false);
        return;
      }

      const modalInstance = $uibModal.open({
        template: completeProfileTemplate,
        controller: 'completeProfileModalCtrl',
        windowClass: 'complete-profile-modal',
        backdrop: true,
        keyboard: true,
        scope: $rootScope.$new(),
        resolve: {
          input: {
            config: authConfig
          }
        }
      });

      modalInstance.result
        .then(() => {
          success();
        })
        .catch(() => {
          error();
        });
    }

    editProfile() { //eslint-disable-line
      $uibModal.open({
        template: editProfileModalTemplate,
        controller: 'editProfileModalCtrl',
        windowClass: 'edit-form-modal',
        backdrop: true,
        keyboard: true,
        scope: $rootScope.$new()
      });
    }

    editContactInformation() { //eslint-disable-line
      $uibModal.open({
        template: editContactInformationModalTemplate,
        controller: 'editContactInformationModalCtrl',
        windowClass: 'edit-form-modal',
        backdrop: true,
        keyboard: true,
        scope: $rootScope.$new()
      });
    }

    editCreditCard(input, success, error) { //eslint-disable-line
      $uibModal.open({
        template: editCreditCardModalTemplate,
        controller: 'editCreditCardModalCtrl',
        windowClass: 'edit-form-modal',
        backdrop: true,
        keyboard: true,
        scope: $rootScope.$new()
      });
    }

    editMembership(input, success, error) { //eslint-disable-line
      const modalInstance = $uibModal.open({
        template: editMembershipModalTemplate,
        controller: 'editMembershipModalCtrl',
        windowClass: 'edit-form-modal',
        backdrop: true,
        keyboard: true,
        scope: $rootScope.$new()
      });

      modalInstance.result
        .then(() => {
          success();
        })
        .catch(() => {
          error();
        });
    }

    editCities() { //eslint-disable-line
      $uibModal.open({
        template: editCitiesModalTemplate,
        controller: 'editCitiesModalCtrl',
        windowClass: 'edit-form-modal',
        backdrop: true,
        keyboard: true,
        scope: $rootScope.$new()
      });
    }

    enterPromo() { //eslint-disable-line
      $uibModal.open({
        template: enterPromoModalTemplate,
        controller: 'enterPromoModalCtrl',
        windowClass: 'edit-form-modal',
        backdrop: true,
        keyboard: true,
        scope: $rootScope.$new()
      });
    }

    forgotPassword(input, success, error) { //eslint-disable-line
      $uibModal.open({
        template: forgotPasswordModalTemplate,
        controller: 'forgotPasswordModalCtrl',
        windowClass: 'edit-form-modal',
        backdrop: true,
        keyboard: true,
        scope: $rootScope.$new(),
        resolve: {
          input
        }
      });
    }

    contactSupport(input) { //eslint-disable-line
      $uibModal.open({
        template: contactSupportModalTemplate,
        controller: 'contactSupportModalCtrl',
        windowClass: 'edit-form-modal',
        backdrop: true,
        keyboard: true,
        scope: $rootScope.$new(),
        resolve: {
          input
        }
      });
    }

    bookingWidget(input) { //eslint-disable-line
      $uibModal.open({
        template: bookingWidgetModalTemplate,
        controller: 'bookingWidgetModalCtrl',
        windowClass: 'venue-book-modal',
        backdrop: true,
        keyboard: true,
        scope: $rootScope.$new(),
        resolve: {
          input
        }
      });
    }

    shareLink(input) { //eslint-disable-line
      $uibModal.open({
        template: shareLinkModalTemplate,
        controller: 'shareLinkModalCtrl',
        windowClass: 'venue-book-modal',
        backdrop: true,
        keyboard: true,
        scope: $rootScope.$new(),
        resolve: {
          input
        }
      });
    }

    authUser(success, error, authConfig) { //eslint-disable-line
      let user = userService.currentUser();
      let token = authService.authToken();

      if (user && token) {
        return success({
          user: user,
          token: token
        });
      }

      if (!authConfig) {
        authConfig = {};
      }

      const modalInstance = $uibModal.open({
        template: loginModalTemplate,
        controller: 'loginModalCtrl',
        windowClass: 'login-modal',
        backdrop: true,
        keyboard: true,
        hideClose: false,
        startState: (authConfig.startState) ? authConfig.startStatetState : 'newUser',
        scope: $rootScope.$new(),
        resolve: {
          input: authConfig
        }
      });

      modalInstance.result
        .then(() => {
          user = userService.currentUser();
          token = authService.authToken();

          $rootScope.currentUser = user;

          if (success) {
            success({
              user,
              token
            });
          }
        })
        .catch(() => {
          if (error) {
            error(false);
          }
        });
    }

    getMembership() { //eslint-disable-line
      $uibModal.open({
        template: getMembershipModalTemplate,
        controller: 'getMembershipModalCtrl',
        windowClass: 'membership-modal',
        backdrop: true,
        keyboard: true,
        scope: $rootScope.$new()
      });
    }

    search() { //eslint-disable-line
      $uibModal.open({
        template: searchModalTemplate,
        controller: 'searchModalCtrl',
        windowClass: 'search-modal',
        backdrop: true,
        keyboard: true,
        scope: $rootScope.$new()
      });
    }

    terms(input) { //eslint-disable-line
      $uibModal.open({
        template: termsModalTemplate,
        controller: 'termsModalCtrl',
        backdrop: true,
        keyboard: true,
        scope: $rootScope.$new(),
        resolve: {
          input
        }
      });
    }

    dismissAll() { //eslint-disable-line
      $uibModalStack.dismissAll();
    }
  }

  /**
   * @param {Function} reject
   */
  function _catchModalError(reject) {
    return function(error) {
      if (error && (error === 'backdrop click' || error === 'escape key press')) return; //just eat these because they aren't really errors

      reject(error);
    };
  }

  return new ModalService();
}



// WEBPACK FOOTER //
// ./src/services/modal/modalService.js